export default __webpack_public_path__ + "static/media/fast_track1.6f7d2ab2.svg";